import { render, staticRenderFns } from "./MateriaPrimeraList.vue?vue&type=template&id=ffc6df7a&scoped=true"
import script from "./MateriaPrimeraList.vue?vue&type=script&lang=js"
export * from "./MateriaPrimeraList.vue?vue&type=script&lang=js"
import style0 from "./MateriaPrimeraList.vue?vue&type=style&index=0&id=ffc6df7a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffc6df7a",
  null
  
)

export default component.exports